import React from 'react';
import ProfitDashboard from '../components/trading/ProfitDashboard';

const ProfitAnalytics: React.FC = () => {
  return <ProfitDashboard />;
};

export default ProfitAnalytics;
